module.exports = __webpack_public_path__ + "static/scholle-748a87b41f285e3f1efb8438bc0d1a2f.png";